import { create } from 'zustand';
import type { ChatMentionsMenuItemType } from '@terra/ui-design-system';
import type { OpenMainContentTabInput } from './layoutStore';

export enum GlobalMenuItemsTypeEnum {
  OPEN_IN_NEW_TAB = 'open-in-new-tab',
  SEND_TO_CHAT = 'send-to-chat',
}

export type SendToChatMenuItem = {
  type: GlobalMenuItemsTypeEnum.SEND_TO_CHAT;
  mention: ChatMentionsMenuItemType;
  contextMessage?: string;
  linkedObject?: {
    kind: string;
    id: string;
    label?: string;
  };
  onClick?: () => void;
};

export type GlobalMenuItems =
  | {
      type: GlobalMenuItemsTypeEnum.OPEN_IN_NEW_TAB;
      tab: OpenMainContentTabInput;
      onClick?: () => void;
    }
  | SendToChatMenuItem;

type GlobalContextMenuState = {
  isOpen: boolean;
  x: number;
  y: number;
  items: GlobalMenuItems[];
};

type OpenGlobalContextMenuParams = {
  x: number;
  y: number;
  items: GlobalMenuItems[];
};

type GlobalContextMenuStoreState = {
  menuState: GlobalContextMenuState;
  openMenu: (params: OpenGlobalContextMenuParams) => void;
  closeMenu: () => void;
};

const CLOSED_MENU_STATE: GlobalContextMenuState = {
  isOpen: false,
  x: 0,
  y: 0,
  items: [],
};

export const useGlobalContextMenuStore = create<GlobalContextMenuStoreState>(
  (set) => ({
    menuState: CLOSED_MENU_STATE,
    openMenu: (params) => {
      set({
        menuState: {
          isOpen: true,
          x: params.x,
          y: params.y,
          items: params.items,
        },
      });
    },
    closeMenu: () => {
      set({ menuState: CLOSED_MENU_STATE });
    },
  }),
);
